import { render, staticRenderFns } from "./EditFormArray.vue?vue&type=template&id=3b8ab2ea"
import script from "./EditFormArray.vue?vue&type=script&lang=js"
export * from "./EditFormArray.vue?vue&type=script&lang=js"
import style0 from "./EditFormArray.vue?vue&type=style&index=0&id=3b8ab2ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports